import type * as React from 'react';
import { put } from '@Domain/Api';
import templateAssignmentScopePath from '@Application/Documents/TemplateAssignments/templateAssignmentScopePath';
import templateAssignmentSaved, {
	type TemplateAssignmentSavedAction,
	type TemplateAssignmentSavedPayload,
} from '@Application/Documents/TemplateAssignments/Actions/templateAssignmentSaved';
import templateAssignmentSaveFailed, {
	type TemplateAssignmentSaveFailedAction,
} from '@Application/Documents/TemplateAssignments/Actions/templateAssignmentSaveFailed';
import type SaveTemplateAssignment from '@Application/Documents/TemplateAssignments/Commands/SaveTemplateAssignment';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = TemplateAssignmentSavedAction | TemplateAssignmentSaveFailedAction;

export default (command: SaveTemplateAssignment) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await put<TemplateAssignmentSavedPayload>(
				`${parameters.api.host}/api/${templateAssignmentScopePath(command.scope)}/${command.documentTypeId}`,
				command.toJSON(),
			);

			const action = templateAssignmentSaved(payload, command.scope);
			dispatch(action);
			return action;
		} catch (error) {
			const action = templateAssignmentSaveFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
